import { createFileRoute, Link } from '@tanstack/react-router';

import { pageHead } from '../lib/seo';
import { SITEMAP_DESCRIPTION, canonical } from '../lib/site';
import { PageContainer } from '../components/layout/page-container';
import { PageHeader } from '../components/ui/page-header';

/**
 * HTML sitemap (/sitemap) — 메뉴까지만: 홈 · 지원사업 · 아티클 · 커뮤니티 · 마이페이지.
 * 서버가 같은 화면을 그린다 — 크롤러도 이 링크를 본다.
 */
export const Route = createFileRoute('/sitemap')({
  head: () => pageHead({ title: '사이트맵', description: SITEMAP_DESCRIPTION, url: canonical('/sitemap'), type: 'website' }),
  component: SitemapPage,
});

const linkCls = 'text-primary hover:underline';

function SitemapPage() {
  return (
    <PageContainer>
      <PageHeader
        title="사이트맵"
        description="좋소 과수원의 전체 페이지와 글 목록입니다."
      />

      <section>
        <h2 className="mb-2 text-base font-bold text-text">메뉴</h2>
        <ul className="space-y-1 text-sm">
          <li>
            <Link to="/" className={linkCls}>
              홈
            </Link>
          </li>
          <li>
            <Link to="/news" className={linkCls}>
              지원사업
            </Link>
          </li>
          <li>
            <Link to="/articles" className={linkCls}>
              아티클
            </Link>
          </li>
          <li>
            <Link to="/posts" className={linkCls}>
              커뮤니티
            </Link>
          </li>
          <li>
            <Link to="/about" className={linkCls}>
              소개
            </Link>
          </li>
          <li>
            <Link to="/mypage" className={linkCls}>
              마이페이지
            </Link>
          </li>
        </ul>
      </section>
    </PageContainer>
  );
}
